import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import _ from 'lodash';
import Translate from 'translate';

import IncmsService from 'services/IncmsService'
import ChannelCaseService from 'services/ChannelCaseService'
import { FormGroup, Select, Textarea } from 'components/FormElements/';
import { toggleAlertError, toggleLoading } from 'stores/actions/';
import { required } from 'constants/InputErrors';

class AssignCaseModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      offices: [],
      employees: []
    };

    this.employeesList = [];
    this.submitForm = this.submitForm.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if ( !this.props.open && nextProps.open ) {
      this.getData( nextProps.case )
    }
  }

  getData( data ) {
    this.props.toggleLoading( true );

    IncmsService.getRccsOffices( data.id ).then( ( response ) => {
      this.props.toggleLoading( false );

      if ( response.data ) {
        this.employeesList = response.data.employeeList;
        this.setState( { offices: response.data.officeList } );
      }
    } );
  }

  getEmployees( office ) {
    if ( !office ) return this.setState( { employees: [] } );

    const employees = _.filter( this.employeesList, { idOffice: office } );
    this.setState( { employees } );
  }

  submitForm( data ) {
    const { onClose, onReloadData, toggleAlertError, toggleLoading } = this.props;

    toggleLoading( true );

    ChannelCaseService.assignRccs( this.props.case.id, data ).then( ( response ) => {
      toggleLoading( false );
      if ( response.errors ) return toggleAlertError( response.errors );

      onReloadData( response.data );
      onClose()
    } )
  }

  render() {
    const { onClose, open, externalCustomer } = this.props;

    return (
      <Modal closeOnEsc={false}
             closeOnOverlayClick={false}
             little
             modalClassName="col-md-6"
             open={open}
             onClose={onClose}>
        <h5 className="mt-0"><Translate id="assignCase"/></h5>

        <Form onSubmit={this.submitForm}
              validate={( values ) => {
                return {
                  idOffice: required( values.idOffice ),
                  idEmployee: externalCustomer !== 'kplc' ? required( values.idEmployee ) : null,
                  comments: required( values.comments )
                }
              }}
        >
          {( { getValue, setValue, submitForm } ) =>
            <form onSubmit={submitForm}>
              <div className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="office"/></label>
                  <Select field="idOffice" className="form-control" placeholder=""
                          valueKey="idOffice" labelKey="officeName"
                          options={this.state.offices}
                          onChange={( value ) => {
                            setValue( 'idEmployee', null );
                            this.getEmployees( value )
                          }}
                  />
                </FormGroup>

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="user"/></label>
                  <Select field="idEmployee" className="form-control" placeholder=""
                          valueKey="idEmployee" labelKey="employeeName"
                          options={this.state.employees}
                  />
                </FormGroup>
              </div>

              <FormGroup>
                <label><Translate id="comment"/></label>
                <Textarea field="comments" className="form-control" rows={5}/>
              </FormGroup>

              <div className="text-right">
                <button className="btn btn-info"><Translate id="submit"/></button>
              </div>
            </form>
          }
        </Form>
      </Modal>
    )
  }
}

const mapStateToProps = ( state, ownProps ) => ( {
  externalCodes: state.settings.externalCodes,
  externalCustomer: state.settings.externalCustomer,
  locale: state.settings.locale.locale,
} );

const mapDispatchToProps = dispatch => ({
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( AssignCaseModal );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/AssignCaseModal/index.js